import { render, staticRenderFns } from "./InfoBencana.vue?vue&type=template&id=897cc4e8&scoped=true"
import script from "./InfoBencana.vue?vue&type=script&lang=js"
export * from "./InfoBencana.vue?vue&type=script&lang=js"
import style0 from "./InfoBencana.vue?vue&type=style&index=0&id=897cc4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897cc4e8",
  null
  
)

export default component.exports